<template>
  <button
    :disabled="!isEnabled"
    type="button"
    :class="[
      'rounded-full p-1.5',
      isEnabled ? `text-${color}-500 hover:bg-${color}-50` : 'text-gray-400 cursor-not-allowed',
    ]"
    @click="onAction">
    <component :is="icon" class="size-4" />
  </button>
</template>

<script setup lang="ts">
const props = defineProps({
  isEnabled: {
    type: Boolean,
    default: true,
  },
  icon: {
    type: Object,
    required: true,
  },
  color: {
    type: String,
    default: 'blue',
  },
});

const emit = defineEmits(['action']);

function onAction() {
  if (props.isEnabled) {
    emit('action');
  }
}
</script>
